export default __webpack_public_path__ + "static/media/html_pricing.66f617ce.md";